export function getEmojiForRating(rating: number) {
  const emojiMap: { [key: number]: string } = {
    1: '😞',
    2: '😕',
    3: '😐',
    4: '🙂',
    5: '😃',
  };

  return emojiMap[rating] || '😐';
}
